import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { PedidoActualEntity } from '../../../private/shared/models/productos';


@Component({
  selector: 'app-order-progress',
  templateUrl: './order-progress.page.html',
  styleUrls: ['./order-progress.page.scss'],
})
export class OrderProgressPage implements OnInit, OnDestroy {

  @Input() order: PedidoActualEntity = {} as PedidoActualEntity;

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
  }

  ngOnDestroy() { }

  public onAccept = () => this.modalCtrl.dismiss();

}
